import { OUTLOOK_PH_INTRO, OUTLOOK_PH_SLUG } from '@/content/outlookPharmaceutical'
import { outlook } from '@/content/reportBuilder'
import type { Report } from '@/content/reportBuilder'

export const report: Report = {
  // The fourteenth report with a designed page of its own, and the fifth Future
  // 2030 outlook — asked for on 2026-08-28 in the same words as the Manufacturing,
  // Consumer Goods and Retail ones (*"referans alarak ilgili sayfayı birebir tıpa
  // tıp aynısını tasarla"*) with a five-part full-page capture of the live page and
  // five of the images it carries. See `content/outlookPharmaceutical.ts` and
  // `pages/OutlookPharmaceutical.tsx`.
  ...outlook(
    OUTLOOK_PH_SLUG,
    'Pharmaceutical',
    'Future 2030: Digital Transformation Outlook for the Pharmaceutical Industry',
    'future-2030-outlook-pharmaceutical-cover',
    '452a18ce-5321-4a97-8a6e-7ec29c4a8b1c-digitopia-digital-transformation-outlook-pharma-2030.pdf',
  ),
  // The hero's own two lines, joined into one paragraph — same as the four outlook
  // entries below, and for the same reason: this page draws its hero from
  // `OUTLOOK_PH_INTRO` directly, so `body` feeds exactly one thing, the meta
  // description `prerender.tsx` takes from `body[0]`.
  body: [`${OUTLOOK_PH_INTRO.lede} ${OUTLOOK_PH_INTRO.body}`],
  layout: 'pharmaceutical-outlook',
  // Its own words, its cover, its file and the five images its bands draw, so
  // `stillToCome` has nothing left to say about it. What is still open is
  // section-by-section on its page, and `outlookPharmaceuticalChecks()` carries
  // that into the manifest.
  check: undefined,
}

/** Its place in the index grid — the order the imported page listed them. */
export const order = 26
